// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".borderLink{color:#582c83;cursor:pointer;font-size:1.2rem;font-weight:700;letter-spacing:.05em;line-height:1.5rem;padding-bottom:.6rem;position:relative;text-transform:uppercase}.borderLink:before{background-color:#582c83;bottom:0;content:\"\";height:2px;left:0;position:absolute;transition:width .3s;width:100%}.borderLink:hover:before{width:30%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
